export const articles = [
  {
    id: "a1",
    title: "顶流男星人设崩塌：私密录音曝光，粉丝集体脱粉",
    slug: "dingliu-nanxing-renshe-bengta",
    category: "明星黑料",
    categorySlug: "mingxing-heiliao",
    excerpt: "某顶流男星深夜私密录音被曝光，涉及不当言论与感情纠葛，粉丝站纷纷宣布关闭，商业价值一夜蒸发超3亿。",
    content: "近日，某顶流男星一段长达15分钟的私密录音在网络疯传。录音中，该男星不仅言辞粗鄙，更涉及与多名女性的感情纠葛。事件爆发后，该男星代言的12个品牌方陆续宣布解约，微博粉丝数在24小时内暴跌200万。更有知情者爆料，这只是冰山一角，后续或有更多实锤证据陆续放出。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20dark%20stage%20with%20microphone%20and%20shadowy%20figure%2C%20entertainment%20scandal%20atmosphere%2C%20cinematic%20red%20and%20black%20lighting%2C%20high%20contrast%20editorial%20photography&width=800&height=800&seq=art-a1&orientation=squarish",
    author: "圈内深扒姐",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20journalist%20portrait%20headshot%20on%20neutral%20background%2C%20confident%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a1&orientation=squarish",
    publishDate: "2026-07-02",
    heat: 9872,
    views: 1284500,
    tags: ["顶流男星", "人设崩塌", "私密录音", "品牌解约"],
  },
  {
    id: "a2",
    title: "千万网红翻车现场：直播间翻车全过程被录屏",
    slug: "qianwan-wanghong-fanche",
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    excerpt: "某千万粉丝网红在直播中意外暴露真实人品，怼粉、虚假宣传、产品质量问题一并被扒，口碑断崖式下跌。",
    content: "昨晚，拥有2800万粉丝的头部美妆网红在直播中情绪失控，对着质疑产品效果的粉丝破口大骂。更被扒出此前推荐的\"大牌同款\"实为三无产品，工厂照片曝光后引发全网声讨。目前该网红已删除全部争议视频并关闭评论，但网友录屏早已满天飞。",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20recording%20livestream%20broadcast%20with%20angry%20reaction%2C%20social%20media%20drama%20atmosphere%2C%20dark%20background%20with%20red%20accents%2C%20cinematic%20editorial%20style&width=800&height=800&seq=art-a2&orientation=squarish",
    author: "瓜田守望者",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20male%20reporter%20portrait%20headshot%20on%20neutral%20background%2C%20observant%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a2&orientation=squarish",
    publishDate: "2026-07-01",
    heat: 8654,
    views: 985600,
    tags: ["千万网红", "直播翻车", "虚假宣传", "怼粉"],
  },
 {
    id: "a3",
    title: "圈内人爆料：某女演员靠潜规则上位，聊天记录全曝光",
    slug: "nv-yanyuan-qianguize",
    category: "明星黑料",
    categorySlug: "mingxing-heiliao",
    excerpt: "知情人士放出某二线女演员与制片人的完整聊天记录，内容露骨直白，牵扯多位圈内大佬，引发行业地震。",
    content: "一位自称是剧组工作人员的知情人士，在社交平台放出某女演员与多位制片人、导演的完整聊天记录。记录显示该女演员多次以\"周末聊聊剧本\"为由约见资方，并暗示\"付出才有回报\"。目前已牵扯出3位圈内知名制片人，其中一人已婚多年。",
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20theater%20backstage%20with%20red%20velvet%20curtains%20and%20spotlight%2C%20scandal%20atmosphere%2C%20cinematic%20lighting%2C%20editorial%20photography&width=800&height=800&seq=art-a3&orientation=squarish",
    author: "圈内深扒姐",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20journalist%20portrait%20headshot%20on%20neutral%20background%2C%20confident%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a1&orientation=squarish",
    publishDate: "2026-06-30",
    heat: 7432,
    views: 876300,
    tags: ["潜规则", "女演员", "制片人", "聊天记录"],
  },
  {
    id: "a4",
    title: "反差视频：知名企业家私下竟是夜店常客，与多名网红同框",
    slug: "fan cha-shipin-qiyejia",
    category: "反差视频",
    categorySlug: "fancha-shipin",
    excerpt: "表面正经儒雅的上市公司董事长，私下被拍到在顶级夜店与网红频繁互动，反差之大让网友直呼\"大开眼界\"。",
    content: "某上市公司董事长一直以儒雅学者形象示人，多次在公开场合倡导\"传统文化\"。然而近日流出的一段夜店视频却将其人设彻底击碎——视频中该董事长与多名网红贴身热舞，更被拍到与某知名带货主播举止亲密。其公司股票今日开盘即跌3.2%。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20nightclub%20interior%20with%20neon%20lights%20and%20dramatic%20silhouettes%2C%20dark%20atmosphere%20with%20purple%20and%20red%20accents%2C%20cinematic%20editorial%20photography&width=800&height=800&seq=art-a4&orientation=squarish",
    author: "夜店线人",
    authorAvatar: "https://readdy.ai/api/search-image?query=Anonymous%20figure%20in%20shadow%20profile%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=100&height=100&seq=ava-a4&orientation=squarish",
    publishDate: "2026-06-29",
    heat: 6910,
    views: 743200,
    tags: ["反差", "企业家", "夜店", "网红"],
  },
  {
    id: "a5",
    title: "每日大赛：本期最大瓜——选秀C位选手恋情实锤",
    slug: "meiri-dasai-xiuxiu-lianqing",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    excerpt: "本期每日大赛最大瓜新鲜出炉！选秀节目C位出道选手被拍到与同为练习生的恋人同回酒店，大量同框照铁证如山。",
    content: "在刚刚落幕的选秀节目中以断层C位出道的选手，被多家媒体拍到与同为练习生的恋人多次同进同出酒店。粉丝后援会此前多次否认恋情，然而今日流出的同框照片、同一件外套、同一副眼镜让\"只是朋友\"的说法不攻自破。选秀期间即恋爱，这让打投数千万的粉丝情何以堪？",
    image: "https://readdy.ai/api/search-image?query=Concert%20stage%20spotlight%20with%20roaring%20crowd%20in%20background%2C%20talent%20show%20atmosphere%2C%20dramatic%20red%20and%20gold%20lighting%2C%20cinematic%20editorial%20photography&width=800&height=800&seq=art-a5&orientation=squarish",
    author: "选秀吃瓜官",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20energetic%20reporter%20portrait%20headshot%20on%20neutral%20background%2C%20enthusiastic%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a5&orientation=squarish",
    publishDate: "2026-06-28",
    heat: 9120,
    views: 1056700,
    tags: ["选秀", "C位", "恋情", "练习生"],
  },
  {
    id: "a6",
    title: "某男星被曝婚内出轨，小三竟是圈内知名造型师",
    slug: "nanxing-hunnei-chugui",
    category: "明星黑料",
    categorySlug: "mingxing-heiliao",
    excerpt: "已婚男星被妻子闺蜜爆料婚内出轨长达两年，小三身份曝光后更让网友震惊——竟是常年与其合作的知名造型师。",
    content: "某以\"好男人\"形象深入人心的已婚男星，今日被妻子闺蜜放出大量实锤：酒店入住记录、二人亲密合照、甚至还有一段车载录像。更让网友跌破眼镜的是，小三竟是与其合作超过5年的御用造型师，多次在公开场合与其同框。妻子目前尚未公开回应，但已默默取关该造型师所有社交账号。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20wedding%20ring%20on%20dark%20surface%20with%20broken%20glass%20reflection%2C%20marital%20scandal%20atmosphere%2C%20cinematic%20red%20and%20black%20lighting%2C%20editorial%20photography&width=800&height=800&seq=art-a6&orientation=squarish",
    author: "瓜田守望者",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20male%20reporter%20portrait%20headshot%20on%20neutral%20background%2C%20observant%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a2&orientation=squarish",
    publishDate: "2026-06-27",
    heat: 8456,
    views: 967800,
    tags: ["婚内出轨", "已婚男星", "造型师", "实锤"],
  },
  {
    id: "a7",
    title: "百万粉丝博主承认造假：所有\"真实经历\"都是编的",
    slug: "bozhu-zaojia-zhenshi-jingli",
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    excerpt: "以\"真实生活记录\"走红的一位百万粉丝博主，在被前助理爆料后不得不承认：所有感人至深的\"真实经历\"均为团队策划编撰。",
    content: "靠\"北漂女孩逆袭\"系列视频吸粉百万的某博主，其前助理今日放出大量策划文档与脚本截图。截图显示该博主\"被房东赶出门\"、\"靠自己买房\"等催泪视频均有完整脚本与分镜，甚至连\"路人\"都是群演。该博主随后发视频\"道歉\"，声称\"艺术创作需要加工\"，评论区已彻底沦陷。",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20video%20editing%20timeline%20with%20script%20notes%2C%20content%20creation%20studio%2C%20dark%20background%20with%20warm%20accent%20lighting%2C%20editorial%20photography&width=800&height=800&seq=art-a7&orientation=squarish",
    author: "瓜田守望者",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20male%20reporter%20portrait%20headshot%20on%20neutral%20background%2C%20observant%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a2&orientation=squarish",
    publishDate: "2026-06-26",
    heat: 7234,
    views: 812500,
    tags: ["博主造假", "脚本", "真实经历", "群演"],
  },
  {
    id: "a8",
    title: "反差视频：名校教授私下竟是情场高手，多名女生控诉",
    slug: "fan cha-jiaoshou-qingchang",
    category: "反差视频",
    categorySlug: "fancha-shipin",
    excerpt: "某985高校知名教授被多名在校女生联合控诉，表面为人师表，私下却利用职务之便骚扰学生，反差之大令人咋舌。",
    content: "某985高校文学院教授，曾以\"师德楷模\"身份多次登上校报头条。然而近日5名女生联合发布长文，详细描述该教授以\"单独辅导\"为由实施骚扰的经过，并放出大量微信聊天记录。校方已成立调查组，该教授目前被暂停一切教学职务。",
    image: "https://readdy.ai/api/search-image?query=University%20library%20interior%20with%20dramatic%20light%20and%20shadow%20contrast%2C%20academic%20scandal%20atmosphere%2C%20dark%20wood%20and%20warm%20lighting%2C%20cinematic%20editorial%20photography&width=800&height=800&seq=art-a8&orientation=squarish",
    author: "校园线报",
    authorAvatar: "https://readdy.ai/api/search-image?query=University%20student%20portrait%20headshot%20on%20neutral%20background%2C%20serious%20expression%2C%20editorial%20style&width=100&height=100&seq=ava-a8&orientation=squarish",
    publishDate: "2026-06-25",
    heat: 6789,
    views: 743600,
    tags: ["名校教授", "骚扰", "师德", "985"],
  },
];

export const featuredArticles = [articles[0], articles[1], articles[4], articles[5]];

export const exclusiveArticles = [articles[2], articles[3], articles[6], articles[7]];